import { createFileRoute } from "@tanstack/react-router"
import { Flex, Text } from "@ui"
import type { FC } from "react"

export const NotFound: FC = () => {
  return (
    <Flex>
      <Text>No solution found</Text>
    </Flex>
  )
}

export const Route = createFileRoute("/_authenticated/superpowers/NotFound")({
  component: NotFound,
})
